import React from 'react';
import {
  CModal, CModalHeader, CModalTitle, CModalBody,
  CTable, CTableHead, CTableBody, CTableRow, CTableHeaderCell, CTableDataCell,
  CSpinner,
} from '@coreui/react';
import AgingBadge from './AgingBadge';

const STATUS_LABELS = {
  pending_approval: 'Pending Approval',
  approved_not_started: 'Approved / Not Started',
  job_posting: 'Job Posting',
  interview_scheduled: 'Interview Scheduled',
  waiting_interview_result: 'Waiting for Result',
  offer_sent: 'Offer Sent',
  accepted_waiting_start: 'Accepted / Waiting',
  started: 'Started',
  cancelled_on_hold: 'Cancelled',
};

export default function DrillDownDialog({ open, onClose, title, data, loading }) {
  return (
    <CModal visible={open} onClose={onClose} size="xl" data-testid="drill-down-dialog">
      <CModalHeader>
        <CModalTitle className="fw-bold">{title}</CModalTitle>
      </CModalHeader>
      <CModalBody style={{ maxHeight: '65vh', overflowY: 'auto' }}>
        <p className="text-body-secondary small mb-3">
          {data?.length || 0} recruitment case{(data?.length || 0) !== 1 ? 's' : ''} found
        </p>
        {loading ? (
          <div className="text-center py-5" data-testid="drill-down-loading">
            <CSpinner color="primary" size="sm" />
          </div>
        ) : !data?.length ? (
          <div className="text-center py-5 text-body-secondary" data-testid="drill-down-empty">No cases found</div>
        ) : (
          <CTable hover small>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="small text-uppercase text-body-secondary">Project</CTableHeaderCell>
                <CTableHeaderCell className="small text-uppercase text-body-secondary">Position</CTableHeaderCell>
                <CTableHeaderCell className="small text-uppercase text-body-secondary text-center">Qty</CTableHeaderCell>
                <CTableHeaderCell className="small text-uppercase text-body-secondary">Status</CTableHeaderCell>
                <CTableHeaderCell className="small text-uppercase text-body-secondary">Aging</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {data.map((item, i) => (
                <CTableRow key={item.case_id || i}>
                  <CTableDataCell className="small fw-medium">{item.project_name}</CTableDataCell>
                  <CTableDataCell className="small">{item.position_name}</CTableDataCell>
                  <CTableDataCell className="small text-center font-monospace">{item.qty}</CTableDataCell>
                  <CTableDataCell className="small">{STATUS_LABELS[item.status] || item.status}</CTableDataCell>
                  <CTableDataCell><AgingBadge days={item.aging_days} group={item.aging_group} /></CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
        )}
      </CModalBody>
    </CModal>
  );
}
